import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import oauthReducer from './slices/oauth';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
    oauth: oauthReducer,
});

export { rootPersistConfig, rootReducer };
